import * as t from "io-ts";

export const PermissionABACPolicyAssocValidator = t.intersection([
  t.type({
    id: t.string,
    permissionId: t.string,
    abacPolicyId: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    permissionName: t.string,
    abacPolicyName: t.string,
    abacPolicyExpression: t.string,
    createdById: t.string,
    lastModifiedById: t.string,
  }),
]);

export const PermissionABACPolicyAssocArrayValidator = t.array(
  PermissionABACPolicyAssocValidator
);

export type PermissionABACPolicyAssoc = t.TypeOf<typeof PermissionABACPolicyAssocValidator>;
export type PermissionABACPolicyAssocArray = t.TypeOf<typeof PermissionABACPolicyAssocArrayValidator>;
